import { Model } from "../../model";
import { ProductionPeriod } from "./production-period";
import { DateUtil } from "../../../util/date-util";
import { Culture } from "../../culture/culture";

export class AgriculturalYear implements Model{
    _id: string;
    year: number;
    initialDate: Date;
    endDate: Date;
    environmentId: string;
    productionPeriods: ProductionPeriod[];

    constructor(obj: any) {
        this._id = obj._id;
        this.year = obj.year;
        this.initialDate = obj.initialDate;
        this.endDate = obj.endDate;
        this.environmentId = obj.environmentId;
        this.productionPeriods = obj.productionPeriods;
    };

    public static PERIODS_REDUCE: Function = (year: AgriculturalYear) => year.productionPeriods; 

    public removePeriod(period: ProductionPeriod): void {
        this.productionPeriods.splice(this.productionPeriods.findIndex(p => p._id == period._id), 1);
    }

    public getCultures(): Culture[] {
        const cultures = this.productionPeriods
            .map(period => period.culture)
            .reduce((c1, c2) => c1.concat(c2), [])
            .filter( ( elem, index, arr ) => arr.indexOf( elem ) === index );
        return cultures;
    }

    public static prepareToApiRequest(agrYear: any) {
        let dateUtil: DateUtil = new DateUtil();

        agrYear.initialDate = dateUtil.dateToApiDateFormat(agrYear.initialDate);
        agrYear.endDate = dateUtil.dateToApiDateFormat(agrYear.endDate);

        agrYear.productionPeriods.map((productionPeriod: any) => {
            productionPeriod.initialDate = dateUtil.dateToApiDateFormat(productionPeriod.initialDate);
            productionPeriod.endDate = dateUtil.dateToApiDateFormat(productionPeriod.endDate);
            if(!productionPeriod._id) 
                delete productionPeriod._id;
        });

        if(!agrYear._id)
            delete agrYear._id;
    }
}